module.exports = __webpack_public_path__ + "static/media/gryphon-house-hero.a1e6fd2b.jpeg";